<form [formGroup]="formDatosFinancierosModal">
  <div class="row">
    <div class="col">
      <div class="md-form">
        <mdb-select [options]="optionsCondicionPago" placeholder="Condición de pago" [filterEnabled]="true"
          formControlName="condicionPago"></mdb-select>
        <label>Condición de pago<app-required-field></app-required-field></label>
        <div *ngIf="
                formDatosFinancierosModal.get('condicionPago').invalid &&
                (formDatosFinancierosModal.get('condicionPago').dirty ||
                formDatosFinancierosModal.get('condicionPago').touched)
                ">
          <mdb-error
            *ngIf="formDatosFinancierosModal.get('condicionPago').hasError('required') || formDatosFinancierosModal.get('condicionPago').hasError('min')">
            Ingrese condición de pago</mdb-error>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="md-form">
        <mdb-select [options]="optionsListaPrecios" placeholder="Lista de precios" [filterEnabled]="true"
          formControlName="listaPrecios"></mdb-select>
        <label>Lista de precios <app-required-field></app-required-field></label>
        <div *ngIf="
                formDatosFinancierosModal.get('listaPrecios').invalid &&
                (formDatosFinancierosModal.get('listaPrecios').dirty ||
                formDatosFinancierosModal.get('listaPrecios').touched)
                ">
          <mdb-error
            *ngIf="formDatosFinancierosModal.get('listaPrecios').hasError('required') || formDatosFinancierosModal.get('listaPrecios').hasError('min')">
            Ingrese lista de precios</mdb-error>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="md-form">
        <input value="" type="text" id="limiteCrediro" class="form-control" placeholder="Límite de crédito" required
          #limiteCrediro formControlName="limiteCredito" monto />
        <label for="limiteCrediro">Limite de crédito</label>
        <!-- <div *ngIf="
                                formDatosFinancierosModal.get('limiteCredito').invalid &&
                                (formDatosFinancierosModal.get('limiteCredito').dirty ||
                                formDatosFinancierosModal.get('limiteCredito').touched)
                            ">
                            <mdb-error *ngIf="formDatosFinancierosModal.get('limiteCredito').hasError('required')">
                                Ingrese límite de crédito</mdb-error>
                        </div> -->
      </div>
    </div>
    <div class="col">

      <mdb-checkbox formControlName="tieneLimiteCredito" (change)="formDatosFinancierosHandleLimCred()">

        Sin límite

      </mdb-checkbox>

    </div>
  </div>
  <div class="row">
    <!-- Left -->

    <div class="col">
      <div class="md-form">
        <input value="" type="number" id="descuentoMaximo" class="form-control" placeholder="Descuento global"
          step="0.01" max="99.99" min="0.00" required #descuentoMaximo formControlName="descuentoMaximo" />
        <label for="descuentoMaximo">Descuento global</label>
        <div *ngIf="
                            formDatosFinancierosModal.get('descuentoMaximo').invalid &&
                            (formDatosFinancierosModal.get('descuentoMaximo').dirty ||
                            formDatosFinancierosModal.get('descuentoMaximo').touched)
                            ">
          <!-- <mdb-error *ngIf="formDatosFinancierosModal.get('descuentoMaximo').hasError('required')">
                                    Ingrese descuento máximo</mdb-error> -->
          <mdb-error *ngIf="formDatosFinancierosModal.get('descuentoMaximo').hasError('min')">
            Descuento global debe ser mayor o igual a 0 </mdb-error>
          <mdb-error *ngIf="formDatosFinancierosModal.get('descuentoMaximo').hasError('max')">
            Descuento global debe ser menor a 100 </mdb-error>
        </div>
      </div>
    </div>

    <div class="col">


      <mdb-checkbox formControlName="clieneAfectoReglasComerciales">
        Cliente afecto a reglas comerciales
      </mdb-checkbox>


    </div>
  </div>
</form>
